import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setToken } from "src/actions";
import Payments from "src/components/Payments";
import { CreditLoginModal } from "src/components/utils/CreditLoginModal";
import { GET_USER_CREDITS } from "src/graphql/queries/user";
import { useClient } from "urql";

export const contactOptions = [
  {
    label: "Text",
    value: "text",
  },
  {
    label: "Call",
    value: "call",
  },
  {
    label: "Email",
    value: "email",
  },
];

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);

function StepFour(props) {
  const client = useClient();

  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  const user = useRef<{
    email: string;
    credits: number;
    authType?: "email" | "google-oauth2" | null;
  }>({ email: "", credits: 0, authType: null });

  // Check if a user account exists, if so, show the user's credits and ask them to login to use them.
  async function checkEmail(email: string) {
    console.log("Checking email...", email);

    const { data, error } = await client
      .query(GET_USER_CREDITS, {
        email,
      })
      .toPromise();

    if (error) return console.error(error);

    if (data.user.credits > 0) {
      user.current = {
        email,
        credits: data.user.credits,
        authType: data.user.auth_type,
      };
      setShowModal(true);
    }
  }

  const handleCreditLoginSuccess = (
    token: string,
    credits: number,
    authType?: string | null
  ) => {
    dispatch(setToken(token, credits));
    setShowModal(false);
  };

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: {
          theme: "stripe",
        },
      }}
    >
      <Payments checkEmail={checkEmail} {...props} />
      <CreditLoginModal
        visible={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleCreditLoginSuccess}
        userEmail={user.current.email}
        userCredits={user.current.credits}
        authType={user.current.authType}
      />
    </Elements>
  );
}

export default StepFour;
